//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentPlansDeliveryDriver', {
//        templateUrl: 'views/components/views/consignmentPlansDeliveryDriver/consignmentPlansDeliveryDriver.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'consignmentPlansDeliveryDriverService', 'typeaheadService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, consignmentPlansDeliveryDriverService, typeaheadService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let variableNames = {
//                equipment_id: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListDeliveryMethods: [],
//                lockedUpdate: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                const editData = (await consignmentPlansDeliveryDriverService.getEdit({
//                    argtype: argType,
//                    argvalue: argValue
//                }));

//                vm.model.edit = editData;
//                vm.model.edit.phone = editData.phone.replace(': ', '');
//            }

//            async function loadDeliveryMethods() {
//                vm.model.selectListDeliveryMethods = await consignmentPlansDeliveryDriverService.listDeliveryMethods();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'equipment_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.lookUpEquipments({ equipment_name: vm.model.edit[id] || '' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'equipment_name':
//                        if (item) {
//                            vm.model.edit.equipment_id = item?.item_id ?? '';
//                            vm.model.edit.equipment_name = item?.item_name ?? '';

//                            rememberFunc('equipment_id');
//                        } else {
//                            vm.onTypeaheadClear('equipment_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'equipment_name':
//                        vm.model.edit.equipment_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.equipment_id = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('equipment_name');

//                            if (vm.model.edit.equipment_id === '') rememberFunc('equipment_id');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'equipment_name':
//                        vm.model.edit.equipment_id = '';
//                        vm.model.edit.equipment_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'equipment_id':
//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        variableValue = vm.model.edit[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'deliverymethod_no':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.deliverymethod_no) !== true) return;

//                        vm.model.edit.deliverymethod_no = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.deliverymethod_no, true) !== true) return;

//                        vm.model.selectListDeliveryMethods.forEach((item) => {
//                            if (item.deliverymethod_no === value) {
//                                vm.model.edit.phone = item.phone;
//                            }
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            }

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.updateChanges = function () {
//                vm.model.lockedUpdate = true;

//                consignmentPlansDeliveryDriverService.updateDriver({
//                    argtype: argType,
//                    argvalue: argValue,
//                    deliverymethod_no: vm.model.edit.deliverymethod_no,
//                    delivery_phone: vm.model.edit.phone,
//                    equipment_id: vm.model.edit.equipment_id
//                }).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedUpdate = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedUpdate = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadDeliveryMethods();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
